import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";
import Recent from "@/views/Recent.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Recent,
  },
  {
    path: "/recent",
    name: "Recent",
    component: Recent
  },
  {
    path: "/editor/:_id?",
    name: "FSEditor",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Editor" */ "@/views/FSEditor.vue")
  },
  {
    path: "/preview/:_id?",
    name: "preview",
    component: () =>
      import(/* webpackChunkname: "preview" */ "@/views/Preview.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
